'use client'

import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { Modal } from '../modal.tsx'

type ConfirmationModalFooterProps = PropsWithChildren<{ className?: string }>

export const ConfirmationModalFooter = ({
  children,
  className,
}: ConfirmationModalFooterProps) => {
  return (
    <Modal.Footer
      className={cn('self-end justify-end flex-initial flex mt-12', className)}
    >
      {children}
    </Modal.Footer>
  )
}
